<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-container
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-container>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(validateForm)">
          <v-card>
            <v-card-title>
              <span
                style="font-size:24px"
              >
                {{ card_title }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Nickname"
                      rules="required|max:16"
                    >
                      <v-text-field
                        v-model="reply_nickname"
                        :error-messages="errors"
                        prepend-icon="mdi-account"
                        label="Nickname"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Reply Content"
                      rules="max:1000"
                    >
                      <v-textarea
                        v-model="reply_description"
                        :error-messages="errors"
                        prepend-icon="mdi-pencil"
                        label="Reply Content"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="画像"
                    >
                      <v-file-input
                        v-model="reply_image_file"
                        :error-messages="errors"
                        accept="image/png, image/jpeg, image/bmp"
                        prepend-icon="mdi-camera"
                        label="Photo"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
              <!-- <small class="grey--text text--lighten-1 ml-5">
                It is recommended to post anonymously for your privacy protection<br>
              </small> -->
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                :color="site_color"
                class="mx-1 my-3"
                text
                rounded
                large
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                :disabled="buttonLoading"
                :loading="buttonLoading"
                :color="site_color"
                class="mx-1 my-3"
                rounded
                large
                default
                type="submit"
              >
                <v-icon
                  left
                >
                  mdi-send
                </v-icon>
                Post
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </validation-observer>
    </v-dialog>
  </v-row>
</template>

<script>
  import { firebase, db, storage } from '../../plugins/firebase.js'
  import imageCompression from 'browser-image-compression'
  export default {
    name: 'ReplyModalForm',

    props: {
      title: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      card_title: {
        type: String,
        default: '',
      },
    },
    $_veeValidate: {
      validator: 'new',
    },

    data: () => ({
      dialog: false,
      buttonLoading: false,
      reply_nickname: '',
      reply_description: '',
      reply_id: '',
      reply_docref: '',
      reply_image_file: '',
      site_color: '',
    }),
    created () {
      this.site_color = this.$store.state.site_color
    },
    methods: {
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
      },
      async validateForm (scope) {
        // thisのスコープ外になるのでmeに代入
        const self = this
        // reply_idを生成する
        const collectionRef = db.collection('partners').doc(self.$store.state.partner_id).collection('letters').doc(self.$store.state.letter_id).collection('replys')
        self.reply_id = collectionRef.doc().id
        self.reply_docref = collectionRef.doc(self.reply_id)
        // // ファイル名は日付
        const fileName = Date.now()
        // 画像ファイルがあるとき
        if (self.reply_image_file) {
          // 保存ボタンのローディング開始
          self.buttonLoading = true
          // 画像を圧縮する 最大横幅800px
          const compFile = await self.getCompressImageFileAsync(self.reply_image_file)
          storage
            .ref()
            .child(self.$store.state.partner_id + '/letters/' + self.$store.state.letter_id + '/replys/' + self.reply_id + '/' + fileName + '.png')
            .put(compFile).then(function (snapshot) {
              snapshot.ref.getDownloadURL().then(function (url) {
                self.reply_docref
                  .set({
                    reply_nickname: self.reply_nickname,
                    reply_description: self.reply_description,
                    reply_id: self.reply_id,
                    reply_docref: self.reply_docref,
                    reply_image_url: url,
                    is_display: true,
                    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                  }).then(function () {
                    self.reply_nickname = undefined
                    self.reply_description = undefined
                    self.reply_image_file = undefined
                    self.reply_id = undefined
                    self.reply_docref = undefined
                    self.dialog = false
                    self.buttonLoading = false
                    alert('リプライを投稿しました')
                    self.$emit('reply-added-event')
                  }).catch(function (error) {
                    console.log(error)
                    alert('リプライを投稿できませんでした(1)')
                    self.dialog = false
                    self.buttonLoading = false
                  })
              }).catch(function (error) {
                console.log(error)
                alert('リプライを投稿できませんでした(2)')
                self.dialog = false
                self.buttonLoading = false
              })
            }).catch(error => {
              console.log(error)
              alert('リプライを投稿できませんでした(3)')
              self.dialog = false
              self.buttonLoading = false
            })
        // 画像ファイルがない場合
        } else {
          self.reply_docref
            .set({
              reply_nickname: self.reply_nickname,
              reply_description: self.reply_description,
              reply_id: self.reply_id,
              reply_docref: self.reply_docref,
              is_display: true,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            }).then(function () {
              self.reply_nickname = undefined
              self.reply_description = undefined
              self.reply_image_file = undefined
              self.reply_id = undefined
              self.reply_docref = undefined
              self.dialog = false
              self.buttonLoading = false
              alert('リプライを投稿しました')
              self.$emit('reply-added-event')
            }).catch(function (error) {
              console.log('error: ' + error)
              self.dialog = false
              self.buttonLoading = false
              alert('リプライを投稿できませんでした')
            })
        }
      },
      // 画像を圧縮
      getCompressImageFileAsync: async function (file) {
        const options = {
          maxSizeMB: 1, // 最大ファイルサイズ
          maxWidthOrHeight: 800, // 最大画像幅もしくは高さ
        }
        try {
          // 圧縮画像の生成
          return await imageCompression(file, options)
        } catch (error) {
          console.error('getCompressImageFileAsync is error', error)
          throw error
        }
      },
    },
  }
</script>
